export enum ChannelType {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
    CALL = 'CALL',
}

export enum StatusType {
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
    MAX_ATTEMPT = 'MAX_ATTEMPT',
    MAX_TIME = 'MAX_TIME',
    CAN_NOT_GENERATE_OTP = 'CAN_NOT_GENERATE_OTP',
}

export interface ResendConfigType {
    label: string;
    visible: boolean;
    key: string;
}

interface BaseOtpResponse {
    status: StatusType;
    message: string;
    statusCode: string;
    otpRequestTime: string;
    otpResendCooldown?: number;
    attemptsLeft: number;
}

export interface SelfDesignationOtpSendResponse extends BaseOtpResponse {
    resendChannel: {
        hasEmail: boolean;
        resendSms: boolean;
        resendCall: boolean;
    };
    data?: {
        target: string;
        channel: ChannelType;
        status: StatusType;
    };
}

export interface SelfDesignationOtpVerifyResponse {
    target: string;
    channel: ChannelType;
    channelUsed: ChannelType;
    status: StatusType;
    attemptsLeft: number;
}

export interface ResendDropdownProps {
    title: string;
    resendConfig: { label: string; visible: boolean; key: string }[];
    callback: (key: string) => void;
    isDisabled?: boolean;
}